module.exports = __webpack_public_path__ + "img/2024-08-29a_1.190de028.jpg";